import React, { ReactNode, createContext, useContext, useState } from 'react';

interface SpinnerContextProps {
    isShowLoading: boolean;
    toggleLoading: () => void;
    setIsShowLoading: (value: boolean) => void;
}

const SpinnerContext = createContext<SpinnerContextProps | undefined>(undefined);

interface SpinnerProviderProps {
    children: ReactNode;
}

const SpinnerProvider: React.FC<SpinnerProviderProps> = ({ children }) => {
    const [isShowLoading, setIsShowLoading] = useState(false);

    const toggleLoading = () => {
        setIsShowLoading((prev) => !prev);
    };

    return (
        <SpinnerContext.Provider value={{ isShowLoading, toggleLoading, setIsShowLoading }}>
            {children}
        </SpinnerContext.Provider>
    );
};

const useSpinnerContext = (): SpinnerContextProps => {
    const context = useContext(SpinnerContext);
    if (!context) {
        throw new Error('useSpinnerContext phải được sử dụng bên trong SpinnerProvider');
    }
    return context;
};

export { SpinnerProvider, useSpinnerContext };
